<template>
    <div>
        <div class="top-box">
            <div class="top">
                <span>活动起止日期：</span>
                <span>
                    <el-date-picker
                        style="width: 500px;"
                        v-model="chooseTimerRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </span>
            </div>
            <div class="top"><span>备注：</span><span><el-input type="textarea" style="width: 500px;" v-model="remark"></el-input></span></div>
        </div>
        <el-table :data="rateData">
            <el-table-column width="50px">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="scope.$index !== 0 && rateData.length !== 1" icon="el-icon-top" size="mini" @click="upRow(scope.$index)" circle style="margin: 0 10px 0 0;"></el-button>
                    <el-button type="danger" v-if="scope.$index !== 0" icon="el-icon-delete" size="mini" @click="removeRow(scope.$index)" circle style="margin: 5px 10px 5px 0;"></el-button>
                    <el-button type="primary" v-if="rateData.length !== 1 && scope.$index !== rateData.length - 1" icon="el-icon-bottom" size="mini" @click="nextRow(scope.$index)" circle style="margin: 0 10px 0 0;"></el-button>
                </template>
            </el-table-column>
            <el-table-column label='产品' width="230px">
                <template slot-scope="scope">
                    <el-input type="text" size="mini" v-model="scope.row.name" />
                </template>
            </el-table-column>
            <el-table-column label='保障期限' width="120px">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.bzqxType" size="mini" placeholder="请选择" class="policy-box-input" @change="handleBaqxTypeChange(scope.row)">
                        <el-option
                            v-for="(opt, key, index) in bzqxOpt"
                            :key="index"
                            :label="opt.desc"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                    <el-input type="text" size="mini" v-model="scope.row.bzqx" v-if="scope.row.bzqxType !== 1" />
                    <el-select v-model="scope.row.bzqxDetailType" size="mini" placeholder="请选择" class="policy-box-input" v-if="scope.row.bzqxType === 2">
                        <el-option
                            v-for="(opt, key, index) in bzqxDetailOpt"
                            :key="index"
                            :label="opt.desc"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label='缴费期限' width="120px">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.jfqxType" size="mini" placeholder="请选择" class="policy-box-input">
                        <el-option
                            v-for="(opt, key, index) in jfqxOpt"
                            :key="index"
                            :label="opt.desc"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                    <el-input type="text" size="mini" v-model="scope.row.jfqx"  v-if="scope.row.jfqxType !== 1" />
                </template>
            </el-table-column>
            <el-table-column v-for="count in column_count" :label="`第${count}年`" :key="count">
                <template slot-scope="scope">
                    <div class="flex-box" style="justify-content: flex-start;">
<!--                        <el-button type="danger"
                                   icon="el-icon-delete"
                                   size="mini"
                                   v-if="count === column_count"
                                   @click="removeRowYears(scope.$index, count)"
                                   circle
                                   style="margin: 0 10px 0 0;"
                        ></el-button>-->
                        <div>
                            <div><span>费率(%)：</span><el-input type="text" size="mini" v-model="scope.row[`year${count}`]" /></div>
                            <div><span>活动费率(%)</span><el-input :class="!colorType ? 'redTxt' : ''" type="text" size="mini" v-model="scope.row[`activity${count}`]" /></div>
                        </div>
                        <el-button type="primary"
                                   icon="el-icon-circle-plus-outline"
                                   size="mini"
                                   style="margin-left: 10px;"
                                   v-if="count === column_count"
                                   @click="addRowYears()"
                                   plain></el-button>
                    </div>
                </template>
            </el-table-column>
            
        </el-table>
        <el-button type="primary" size="small" style="margin-top: 20px;" @click="handleAddRate">增加一项</el-button>
    </div>
</template>
<script>
export default {
    props: ['productId', 'tableHistory'],
    data(){
        return {
            bzqxOpt: [{value: 1, desc: "终身"}, {value: 2, desc: "保N年/月/日"}, {value: 3, desc: "至N岁"}],
            jfqxOpt: [{value: 1, desc: "趸交"}, {value: 2, desc: "N年交"}, {value: 3, desc: "至N岁"}],
            bzqxDetailOpt: [{value: 1, desc: "年"}, {value: 2, desc: "月"}, {value: 3, desc: "日"}],
            rateData: [{
                name: '', //名称
                bzqx: '', //保障期限
                bzqxType: null,
                bzqxDetailType: null,
                jfqxType: null,
                jfqx: null, // 缴费期限
                year1: null,
                activity1: null, //活动费率
            }],
            column_count: 1,
            chooseTimerRange: [],
            remark: '',
            version: ''
        }
    },
    watch: {
        tableHistory: {
            handler(val, oldVal) {
                let a = {"products": [{"name": "平安e生保长期医疗（费率可调）", "valid_periods": [{"pay_methods": [{"nodes": [{"year": 1, "ratio": 2200, "activity_ratio": 0}, {"year": 2, "ratio": 2200, "activity_ratio": 0}], "pay_method": {"type": 2, "year": 22}}], "valid_period": {"day": 10, "type": 2}}]}], "column_count": 2}
                
                let s = {"column_count":1,"products":[{"name":"测试产品","valid_periods":[{"valid_period":{"type":1},"pay_methods":[{"pay_method":{"type":1},"nodes":[{"year":1,"ratio":500,"activity_ratio":600}]},{"pay_method":{"type":2,"year":10},"nodes":[{"year":1,"ratio":1000,"activity_ratio":0}]},{"pay_method":{"type":2,"year":20},"nodes":[{"year":1,"ratio":2000,"activity_ratio":0}]},{"pay_method":{"type":3,"year":10},"nodes":[{"year":1,"ratio":1100,"activity_ratio":0}]},{"pay_method":{"type":3,"year":20},"nodes":[{"year":1,"ratio":2200,"activity_ratio":0}]},{"pay_method":{"type":2,"year":10},"nodes":[{"year":1,"ratio":1250,"activity_ratio":0}]},{"pay_method":{"type":3,"year":20},"nodes":[{"year":1,"ratio":4230,"activity_ratio":0}]},{"pay_method":{"type":2,"year":10},"nodes":[{"year":1,"ratio":2530,"activity_ratio":0}]},{"pay_method":{"type":2,"year":22},"nodes":[{"year":1,"ratio":2222,"activity_ratio":0}]},{"pay_method":{"type":3,"year":33},"nodes":[{"year":1,"ratio":3333,"activity_ratio":0}]}]},{"valid_period":{"type":2,"day":10},"pay_methods":[{"pay_method":{"type":1},"nodes":[{"year":1,"ratio":1230,"activity_ratio":0}]}]}]}]}

                if(val.length < 1) return
                //console.log(val[0])
                this.remark = val[0].remark || ''
                this.version = val[0].version || ''
                this.chooseTimerRange = [val[0].activity_start_time, val[0].activity_end_time]
                this.column_count = (JSON.parse(val[0].table)).column_count
                let rate = (JSON.parse(val[0].table)).products
                //console.log(rate)
                let table = []
                rate.map((item, index) => {
                    let data = {
                        name: item.name,
                        nameId: index
                    }
                    let validPeriods = item.valid_periods
                    validPeriods.map((bItem, bIndex) => {
                        let data1 = data
                        let type = bItem.valid_period.type
                        let payMethods = bItem.pay_methods

                        //console.log('type', type)
                        let m = bItem.valid_period.hasOwnProperty('year') ? '年' : bItem.valid_period.hasOwnProperty('month') ? '月' : '日'
                        let n = bItem.valid_period.hasOwnProperty('year') ? 'year' : bItem.valid_period.hasOwnProperty('month') ? 'month' : 'day'
                        data1['bzqx'] = type === 1 ? '' : type === 2 ? `${bItem.valid_period[n]}` : `${bItem.valid_period[n]}` //保障期限
                        data1['bzqxType'] = type //保障期限
                        data1['bzqxDetailType'] = m //保障期限
                        data1['bzqxId'] = bIndex //保障期限

                        payMethods.map(cItem => {
                            let data2 = data1
                            data2['jfqx'] = cItem.pay_method.type === 1 ? '' : cItem.pay_method.type === 2 ? `${cItem.pay_method.year}` : `${cItem.pay_method.year}` //缴费期限
                            data2['jfqxType'] = cItem.pay_method.type  //缴费期限
                            let notes = cItem.nodes
                            //console.log(notes, 'notes')
                            for(let i = 0; i < notes.length; i++) {
                                //console.log(i, notes[i], data2)
                                data2[`year${i+1}`] = notes[i].ratio ? `${notes[i].ratio/100}` : ''
                                data2[`activity${i+1}`] = notes[i].activity_ratio ? ` ${notes[i].activity_ratio/100}` : ''
                                
                            }
                            table.push(JSON.parse(JSON.stringify(data2)))
                        })
                    })
                })
                this.rateData = table
                //console.log('table', this.rateData)
            }  
        },
        rateData: {
            handler(val, oldVal){
                //console.log(val, oldVal)
                let table = {"products": [{"name": "测试产品", "valid_periods": [{"pay_methods": [{"nodes": [{"year": 1, "ratio": 500, "activity_ratio": 600}], "pay_method": {"type": 1}}, {"nodes": [{"year": 1, "ratio": 1000, "activity_ratio": 0}], "pay_method": {"type": 2, "year": 10}}, {"nodes": [{"year": 1, "ratio": 2000, "activity_ratio": 0}], "pay_method": {"type": 2, "year": 20}}, {"nodes": [{"year": 1, "ratio": 1100, "activity_ratio": 0}], "pay_method": {"type": 3, "year": 10}}, {"nodes": [{"year": 1, "ratio": 2200, "activity_ratio": 0}], "pay_method": {"type": 3, "year": 20}}, {"nodes": [{"year": 1, "ratio": 1250, "activity_ratio": 0}], "pay_method": {"type": 2, "year": 10}}, {"nodes": [{"year": 1, "ratio": 4230, "activity_ratio": 0}], "pay_method": {"type": 3, "year": 20}}, {"nodes": [{"year": 1, "ratio": 2530, "activity_ratio": 0}], "pay_method": {"type": 2, "year": 10}}], "valid_period": {"type": 1}}, {"pay_methods": [{"nodes": [{"year": 1, "ratio": 1230, "activity_ratio": 0}], "pay_method": {"type": 1}}], "valid_period": {"day": 10, "type": 2}}]}], "column_count": 1}

                this.$emit('getSettingRateData', val, this.column_count)
            },
            deep:true //true 深度监听
        },
        remark: {
            handler(val, oldVal){
                this.$emit('getSettingRateDataRemark', val)
            },
            deep:true //true 深度监听
        },
        version: {
            handler(val, oldVal){
                //console.log(val, oldVal)
                this.$emit('getSettingRateDataVersion', val)
            },
            deep:true //true 深度监听
        },
        chooseTimerRange: {
            handler(val, oldVal){
                //console.log(val, oldVal)
                this.$emit('getSettingRateDataChooseTimerRange', val)
            },
            deep:true //true 深度监听
        },
    },
    computed: {
        colorType() {
            let currentTime = Date.parse(new Date())
            let startTime = Date.parse(this.chooseTimerRange[0])
            let endTime = Date.parse(this.chooseTimerRange[1])
            return currentTime > startTime && currentTime < endTime;
        }  
    },
    methods: {
        handleBaqxTypeChange(row){
            //console.log(row)
            if(row.bzqxType === 2) {
                row.bzqxDetailType = 1
            }
        },
        handleAddRate(){
            let data = {
                name: this.rateData[this.rateData.length - 1].name, //名称
                bzqx: this.rateData[this.rateData.length - 1].bzqx, //保障期限
                bzqxType: this.rateData[this.rateData.length - 1].bzqxType, //保障期限
                bzqxDetailType: this.rateData[this.rateData.length - 1].bzqxDetailType, //保障期限
                jfqx: null, // 缴费期限
                jfqxType: null, // 缴费期限
                year1: null,
                activity1: null, //活动费率
            }
            this.rateData.push(data)
        },
        addRowYears() {
            //增加缴费年限费率
            this.column_count++
        },
        removeRowYears(index, count){
            //删除缴费年限费率
            delete this.rateData[index][`year${count}`] 
        },
        removeRow(index){
            //删除一条数据
            this.rateData.splice(index, 1)
        },
        nextRow(i){
            //console.log(i,this.rateData,this.rateData[i],this.rateData[i+1])
            //当前行向下调整一行数据i
            
            var tempOption = this.rateData[i+1];
            this.$set(this.rateData, i+1, this.rateData[i]);
            this.$set(this.rateData, i, tempOption)
            
        },
        upRow(i){
            //当前行向上调整一行数据
            var tempOption = this.rateData[i-1];
            this.$set(this.rateData, i-1, this.rateData[i]);
            this.$set(this.rateData, i, tempOption)
        }
    }
}
</script>
<style scoped>
.flex-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.redTxt >>> input{
    color: red !important;
}
.top-box .top{
    margin-bottom: 20px;
}
.top-box .top span:nth-child(1){
    display: inline-block;
    width: 100px;
}
</style>
